var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"sidebar"}},[_c('Menu',{attrs:{"id":"sb-main-menu","k":"main-menu","max-depth":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }